<template>
	<header>
		<view class="header_c">
			<view class="category">
				<view class="logo" @click="handleToHome()"></view>
				<view class="editor"></view>
				<view class="tab">
					<view v-for="(item,index) in tabList" :key="index" :class="tabIndex === index ? 'active' : ''"
						class="item" @click="handleTab(item,index)">{{item}}</view>
				</view>
			</view>
			<view class="header_r">
				<view class="item">
					<view class="bg_login"></view>
					<view class="desc">
						<view class="login" @click="handleLogin()">
							{{isToken ? phone : '登录/注册'}}
						</view>
						<view class="loginOut" v-if="isToken ? true : false" @click="handleLoginOut()">【退出】</view>
					</view>
				</view>
				<view class="item" @click="handleCart()">
					<view class="bg_cart"></view>
					<view class="desc">购物车</view>
				</view>
				<view class="item" @click="handleService()">
					<view class="bg_consult"></view>
					<view class="desc">我要咨询</view>
				</view>
			</view>
		</view>
	</header>
</template>

<script>
	export default {
		props: {
			tabIndex: {
				type: Number,
				required: true
			}
		},
		data() {
			return {
				tabList: ['教材', '配套资源', '我的学习', '已购教材', '我的订单', '购物车'],
				isToken: this.$store.state.token ? true : false,
				phone: this.$store.state.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2"),
				userId: this.$store.state.userId
			}
		},
		methods: {
			//获取地址栏参数信息
			getParams() {
				let obj = {};
				let href = window.location.href;

				if (href.includes('?')) {
					let args = href.split('?');

					if (args[0] == href) { //没有传参
						return;
					}

					let arr = args[1].split('&');
					for (var i = 0; i < arr.length; i++) {
						let arg = arr[i].split('=');
						obj[arg[0]] = arg[1];
					}
				}

				return obj;
			},
			//登录页跳转
			handleLogin() {
				if (this.isToken) {
					// console.log(location.hash.includes('myOrder'))
					if (!location.hash.includes('myOrder')) {
						uni.navigateTo({
							url: '/pages/userInfo/myOrder/index?userId=' + this.userId
							// url: '/pages/userInfo/myOrder/index'
						});
					}
				} else {
					uni.navigateTo({
						url: '/pages/login/loginpage/index'
					});
				}
			},
			//退出登录
			handleLoginOut() {
				let dev_pro = process.env.NODE_ENV; //获取环境变量
				let url;
				if (dev_pro == 'development') {
					url = this.baseApi + '/user/ak/pep_click/user/' + this.userId + '/loginOut.json';
				} else {
					url = this.baseURL + '/user/ak/pep_click/user/' + this.userId + '/loginOut.json';
				}

				uni.request({
					url: url,
					method: 'post',
					data: {
						access_token: this.$store.state.token
					},
					header: {
						"Content-Type": "application/x-www-form-urlencoded",
						"version": this.version,
						"app-channel": this.app_channel
					},
					success: res => {
						// console.log(res, '退出登录');
						if (res.statusCode == '200') {
							// this.showTips('退出登录！');
							const randomNumber = Math.floor(Math.random() * 1000); // 随机数
							this.$store.commit('setUserId', randomNumber);
							this.$store.commit('setToken', '');
							this.isToken = this.$store.state.token;

							//清除用户id(用于大数据埋点)
							localStorage.setItem('activeUserId', '-1');
							
							//安全验证，防用户篡改
							localStorage.setItem('userIdStr', "");

							uni.reLaunch({
								url: '/pages/home/index'
							});

						} else {
							this.showTips(res.data.errmsg);
						}
					},
					fail: err => {
						console.log(err);
					}
				})
			},
			//气泡提示
			showTips(title) {
				uni.showToast({
					icon: 'none',
					title: title,
					// duration: 2000
				})
			},
			//购物车跳转
			handleCart() {
				uni.navigateTo({
					url: '/pages/userInfo/myShopCart/index?userId=' + this.userId
				});
			},
			//跳转七鱼平台
			handleService() {
				// console.log(this.isToken)
				if (this.isToken) {
					
					let dev_pro = process.env.NODE_ENV; //获取环境变量
					let url;

					if (dev_pro == 'development') {
						// url = 'http://127.0.0.1:8080/#/pages/consult/index'; //本地环境
						url = 'http://localhost:8080/#/pages/consult/index'; //本地环境
					} else {
						if (location.hostname.indexOf('dianducs') >= 0) {
							url = this.baseURL + '/rjdd/#/pages/consult/index'; //测试环境
						} else {
							url = this.baseURL + '/dist/#/pages/consult/index'; //正式环境
						}
					}

					window.open(url, '_blank');
				} else {
					uni.navigateTo({
						url: '/pages/login/loginpage/index'
					});
				}
			},
			//tab切换
			handleTab(item, index) {
				// console.log(item);
				this.$emit('tabIndex', index); //更新父组件的数据
				switch (item) {
					case '教材':
						uni.reLaunch({
							url: '/pages/home/index'
						});
						break;
					case '配套资源':
						uni.navigateTo({
							url: '/pages/course/index'
						});
						break;
					case '我的学习':
						let url;
						if (this.isToken) {
							// url = '/pages/myStudy/index?userId=' + this.userId
							url = '/pages/myStudy/index'
						} else {
							url = '/pages/myStudy/index'
						}
						uni.navigateTo({
							url: url
						});
						break;
					case '已购教材':
						uni.navigateTo({
							url: '/pages/userInfo/myPurchased/index?userId=' + this.userId
						});
						break;
					case '我的订单':
						uni.navigateTo({
							// url: '/pages/userInfo/myOrder/index?userId=' + this.userId
							url: '/pages/userInfo/myOrder/index'
						});
						break;
					case '购物车':
						uni.navigateTo({
							// url: '/pages/userInfo/myShopCart/index?userId=' + this.userId
							url: '/pages/userInfo/myShopCart/index'
						});
						break;
					default:
						break;
				}
			},
			//点击logo回教材学习
			handleToHome() {
				uni.navigateTo({
					url: '/pages/home/index'
				});
			}
		}
	}
</script>

<style lang="scss" scoped scoped>
	@import "@/style/components/header.scss"; //引入样式文件
</style>
